import { CreateFolderAbstractValidator } from './create.folder.abstract.validator';

export class CreateNetworkFolderActionValidator extends CreateFolderAbstractValidator {
  protected allowTypes = [
    Constants.ProtectedEntities.EPS.CUSTOM_GROUPS,
    Constants.ProtectedEntities.EPS.TYPE_CUSTOM_GROUP,
    Constants.ProtectedEntities.CONTAINERS.TYPE_CUSTOM_GROUPS,
    Constants.ProtectedEntities.CONTAINERS.TYPE_FOLDER,
  ];
}
